import React from 'react'
import NavBar from '@/components/NavBar'
import { ActivityFeed } from '@/components/realtime/ActivityFeed'
import { ConnectionStatus } from '@/components/realtime/ConnectionStatus'

export default function DashboardRealtime() {
  return (
    <div className="min-h-screen flex flex-col">
      <NavBar />
      <main className="flex-1 pt-24">
        <div className="container mx-auto p-6">
          <h1 className="text-2xl font-bold mb-4">Realtime Activity</h1>
          <ActivityFeed />
        </div>
      </main>
      <ConnectionStatus />
    </div>
  )
}


